export default __webpack_public_path__ + "static/slider-ks-3d2163248eea9338c4fb789b22c3465b.jpg";